import React from 'react';
import { ApolloError } from '@apollo/client';
import { CapabilityDelete } from './CapabilityDelete';
import { useCapabilityDeleteMutation } from '../../../__generated__/types';

interface CapabilityDeleteContainerProps {
  id: string;
  isOpen: boolean;
  onCompleted: () => void;
  onCancel: () => void;
  onError: (error: Error | ApolloError) => void;
}

export const CapabilityDeleteContainer: React.FC<
  CapabilityDeleteContainerProps
> = ({ id, isOpen, onCompleted, onError, onCancel }) => {
  const [deleteCapability, { loading, error }] = useCapabilityDeleteMutation({
    onCompleted,
    onError,
  });

  const handleConfirm = () =>
    deleteCapability({
      variables: { capabilityId: id },
    });

  return (
    <CapabilityDelete
      error={error}
      isLoading={loading}
      isOpen={isOpen}
      onConfirm={handleConfirm}
      onClose={onCancel}
    />
  );
};
